import { makeStyles, Theme } from '@material-ui/core/styles';

type StyleProps = {
  isNotRequired?: boolean;
};

export const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  inputRoot: {
    border: ({ isNotRequired }) => `1px solid ${isNotRequired ? '#d96c0b' : '#ed5a4d'} !important`,
  },
  witdh: {
    width: '100%',
  }
}));
